export type ArrivalPresetField = {
  label: string
  fieldType: string
  readOnly: boolean
  required: boolean
  active?: boolean
  unit?: string
  options?: string[] | null
}

export type ArrivalPresetSection = {
  name: string
  fields: ArrivalPresetField[]
}

export const ARRIVAL_PRESET_SECTIONS: ArrivalPresetSection[] = [
  {
    name: 'Voyage Information',
    fields: [
      {label: 'Status', fieldType: 'select', readOnly: false, required: true, active: true, options: ['Ballast', 'Laden', 'In Port', 'At Anchor']},
      {label: 'Vessel Condition', fieldType: 'select', readOnly: false, required: true, active: true, options: ['At Sea', 'At Anchor', 'At Berth', 'Drifting']},
      {label: 'Duration', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'Hrs'},
      {label: 'Departure Port', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'Departure Datetime', fieldType: 'datetime', readOnly: false, required: false, active: true},
      {label: 'Arrival Port', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'ETA Datetime', fieldType: 'datetime', readOnly: false, required: false, active: true},
      {label: 'Date line crossed', fieldType: 'checkbox', readOnly: false, required: false, active: true, options: ['Date line crossed']},
      {label: 'Charter Type', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'Cargo Cooling System In Use', fieldType: 'checkbox', readOnly: false, required: false, active: true, options: ['Cargo Cooling System In Use']},
      {label: 'Vessel Name', fieldType: 'text', readOnly: true, required: true, active: true},
      {label: 'Voyage Number', fieldType: 'text', readOnly: true, required: true, active: true},
      {label: 'Report Type', fieldType: 'text', readOnly: true, required: true, active: true},
      {label: 'Report Date Time', fieldType: 'datetime', readOnly: false, required: true, active: true},
      {label: 'Time Zone', fieldType: 'select', readOnly: false, required: false, active: true, options: ['UTC', 'UTC+05:30', 'UTC+08:00', 'UTC+10:00', 'UTC-05:00']},
    ],
  },
  {
    name: 'Events',
    fields: [
      {label: 'Pilot On Board', fieldType: 'datetime', readOnly: false, required: false, active: true},
      {label: 'Anchor Dropped', fieldType: 'datetime', readOnly: false, required: false, active: true},
      {label: 'All Fast', fieldType: 'datetime', readOnly: false, required: false, active: true},
      {label: 'Notice of Readiness Tendered', fieldType: 'datetime', readOnly: false, required: false, active: true},
      {label: 'Event Remarks', fieldType: 'textarea', readOnly: false, required: false, active: true},
    ],
  },
  {
    name: 'Speed, Position and Distance',
    fields: [
      {label: 'Latitude', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'Longitude', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'Distance Travelled', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'NM'},
      {label: 'Average Speed', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'Knots'},
      {label: 'Course', fieldType: 'text', readOnly: false, required: false, active: true},
    ],
  },
  {
    name: 'Weather and Sea Conditions',
    fields: [
      {label: 'Wind Force', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'Wind Direction', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'Sea State', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'Swell', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'Weather Remarks', fieldType: 'textarea', readOnly: false, required: false, active: true},
    ],
  },
  {
    name: 'Cargo & Stability',
    fields: [
      {label: 'Cargo Name', fieldType: 'text', readOnly: false, required: false, active: true},
      {label: 'Cargo Quantity', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'MT'},
      {label: 'Refrigerated Containers Onboard', fieldType: 'checkbox', readOnly: false, required: false, active: true, options: ['Refrigerated Containers Onboard']},
      {label: 'Draft Forward', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'm'},
      {label: 'Draft Aft', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'm'},
      {label: 'Cargo Remarks', fieldType: 'textarea', readOnly: false, required: false, active: true},
    ],
  },
  {
    name: 'Machinery',
    fields: [
      {label: 'Main Engine Running Hours', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'Hrs'},
      {label: 'Aux Engine Running Hours', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'Hrs'},
      {label: 'Engine Remarks', fieldType: 'textarea', readOnly: false, required: false, active: true},
    ],
  },
  {
    name: 'Running Hours',
    fields: [
      {label: 'Generator 1 Hours', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'Hrs'},
      {label: 'Generator 2 Hours', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'Hrs'},
      {label: 'Boiler Hours', fieldType: 'number', readOnly: false, required: false, active: true, unit: 'Hrs'},
    ],
  },
  {
    name: 'Environmental Compliance',
    fields: [
      {label: 'Fuel Sulphur Content', fieldType: 'number', readOnly: false, required: false, active: true, unit: '%'},
      {label: 'SECA Compliance', fieldType: 'select', readOnly: false, required: false, active: true, options: ['Yes', 'No', 'N/A']},
      {label: 'Garbage Disposal Status', fieldType: 'select', readOnly: false, required: false, active: true, options: ['Completed', 'Pending', 'N/A']},
      {label: 'Environmental Remarks', fieldType: 'textarea', readOnly: false, required: false, active: true},
    ],
  },
]
